import { Radio, theme } from 'antd';
import styled from 'styled-components';
import { devices } from '../../constants/devices';

const ItemsContainer = styled.div<{ $active?: boolean; $color: string }>`
	display: flex;
	gap: 10px;

	@media ${devices.tablet} {
		flex-direction: column;
	}

	.ant-radio-wrapper {
		padding: 15px;
		border: 1px solid #d9d9d9;
		border-radius: 4px;

		font-size: 15px;
		font-weight: 500;
		line-height: 20px;

		align-items: center;

		& > span:first-of-type {
			margin-right: 10px;
		}

		&:hover {
			border-color: ${({ $color }) => $color};
		}
	}

	.active {
		color: ${({ $color }) => $color};
		background-color: ${({ $color }) => $color}20;
		border-color: ${({ $color }) => $color};

		.ant-radio-inner {
			border-color: ${({ $color }) => $color};
			background-color: ${({ $color }) => $color};
		}
	}
`;

type Props = {
	value: string;
	values: { value: string; label: string }[];
	onChange?: (key: string) => void;
};

export const CustomButtonRadio = ({ value, values, onChange }: Props) => {
	const { token } = theme.useToken();

	return (
		<Radio.Group value={value} onChange={e => onChange?.(e.target.value)} style={{ width: '100%' }}>
			<ItemsContainer $color={token.colorPrimary}>
				{values.map(item => (
					<Radio key={item.value} value={item.value} className={item.value === value ? 'active' : ''}>
						{item.label}
					</Radio>
				))}
			</ItemsContainer>
		</Radio.Group>
	);
};
